import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, adminOnly = false, managerOnly = false }) => {
const {
    user,
    loading,
    verificationStatus,
    isAdmin,
    isManager,
  } = useAuth();

  if (loading) return <div>Loading...</div>;
  if (!user) return <Navigate to="/login" />;

  if (verificationStatus === 'APPROVAL_PENDING')
    return <Navigate to="/pending-approval" replace />;

  if (verificationStatus === 'PAYMENT_REQUIRED')
    return <Navigate to="/billing/activate" replace />;
  if (verificationStatus === 'ONBOARDING_REQUIRED')
    return <Navigate to="/book-demo" replace />;

  if (adminOnly && !isAdmin)
    return <Navigate to="/dashboard" replace />;

  if (managerOnly && !(isAdmin || isManager))
    return <Navigate to="/dashboard" replace />;

/*   if (adminOnly && !isAdmin) return <div>❌ Access Denied</div>;
  if (managerOnly && !(isAdmin || isManager)) return <div>❌ Access Denied</div>; */

  return children;
};


export default PrivateRoute;
